import posthog from 'posthog-js'

export function initPosthog() {
  if (posthog.__initialized) return

  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: 'https://eu.posthog.com',   // important: EU project
    capture_pageview: true,               // auto pageviews on load
  })

  // Make PostHog available globally for console testing
  if (typeof window !== 'undefined') {
    window.posthog = posthog;
  }

  posthog.__initialized = true
}

export default posthog
